import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b46aeee4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full min-h-screen flex flex-col clear-both" }
const _hoisted_2 = { class: "text-md" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "sm:mb-8 text-center sm:text-left" }
const _hoisted_5 = ["innerHTML", "disabled"]
const _hoisted_6 = ["innerHTML", "disabled"]
const _hoisted_7 = { class: "flex flex-row items-start flex-wrap sm:flex-nowrap" }
const _hoisted_8 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/stone1.png",
  class: "h-40 mx-4 -mr-4"
}, null, -1))
const _hoisted_11 = { class: "md:w-cards w-full relative z-0" }
const _hoisted_12 = { class: "flex flex-row items-center flex-wrap sm:flex-nowrap" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/stone2.png",
  class: "h-40 md:mx-4 md:-mr-4 mx-auto block"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/girl_holding.svg",
  class: "-mt-6 max-w-16 w-full z-10 mx-auto relative"
}, null, -1))
const _hoisted_17 = { class: "" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "md:w-cards relative z-0" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/girl_holding2.svg",
  class: "-mt-6 max-w-16 w-full z-10 mx-auto relative"
}, null, -1))
const _hoisted_26 = { class: "modal container text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  class: "video-iframe",
  src: "https://www.youtube.com/embed/MLy_7sSBDpY",
  title: "YouTube video player",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
  allowfullscreen: ""
}, null, -1))
const _hoisted_28 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_ReadMore = _resolveComponent("ReadMore")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", {
              innerHTML: _ctx.$t('getMagnets.title'),
              class: "mb-8 font-space text-medium font-bold text-xl"
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                innerHTML: _ctx.$t('getMagnets.fertiliser'),
                class: "orange-button min-w-12",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCard(1))),
                disabled: _ctx.showCard < 3 && _ctx.showCard
              }, null, 8, _hoisted_5),
              _createElementVNode("button", {
                type: "button",
                innerHTML: _ctx.$t('getMagnets.recycle'),
                class: "orange-button sm:ml-4 mt-4 sm:mt-0 min-w-12",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCard(3))),
                disabled: _ctx.showCard > 2
              }, null, 8, _hoisted_6)
            ]),
            _createVNode(_Transition, { name: "show-slow" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createVNode(_component_Card, {
                    title: _ctx.$t('getMagnets.title2'),
                    "title-class": "",
                    class: _normalizeClass(["transition-all md:w-cards w-full mr-auto mt-16", {'opacity-50': _ctx.showCard === 2}])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", {
                          innerHTML: _ctx.$t('getMagnets.text1'),
                          class: "text-justify"
                        }, null, 8, _hoisted_9),
                        _hoisted_10
                      ]),
                      _createElementVNode("img", {
                        src: "img/arrow_right.svg",
                        class: "ml-auto mt-4 w-6 right-arrow",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCard(2)))
                      })
                    ]),
                    _: 1
                  }, 8, ["title", "class"]), [
                    [_vShow, _ctx.showCard < 3 && _ctx.showCard]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Card, {
                      title: _ctx.$t('getMagnets.title3'),
                      "title-class": "text-left-important sm:ml-12",
                      class: "w-full ml-auto mt-4 md:-mt-8 z-0 pb-16",
                      close: "",
                      onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectCard(1)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", {
                              innerHTML: _ctx.$t('getMagnets.text2'),
                              class: "text-justify"
                            }, null, 8, _hoisted_13),
                            _createElementVNode("p", {
                              innerHTML: _ctx.$t('getMagnets.text3'),
                              class: "text-justify"
                            }, null, 8, _hoisted_14)
                          ]),
                          _hoisted_15
                        ])
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _hoisted_16
                  ], 512), [
                    [_vShow, _ctx.showCard === 2]
                  ]),
                  _withDirectives(_createVNode(_component_Card, {
                    title: _ctx.$t('getMagnets.title4'),
                    class: _normalizeClass(["transition-all md:w-cards mt-16 mr-auto", {'opacity-50': _ctx.showCard === 4}])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("p", {
                          innerHTML: _ctx.$t('getMagnets.text4'),
                          class: "text-justify"
                        }, null, 8, _hoisted_18),
                        _createVNode(_component_ReadMore, {
                          onOpen: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$root.setupAndPlayIfOn(_ctx.FILES.audio_get_wise_more))),
                          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$root.stopAudio()))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("p", {
                                innerHTML: _ctx.$t('getMagnets.text5'),
                                class: "text-justify"
                              }, null, 8, _hoisted_19),
                              _createVNode(_component_ReadMore, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", {
                                    innerHTML: _ctx.$t('getMagnets.text6'),
                                    class: "text-justify"
                                  }, null, 8, _hoisted_20)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("img", {
                        src: "img/arrow_right.svg",
                        class: "ml-auto mt-4 w-6 right-arrow",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectCard(4)))
                      })
                    ]),
                    _: 1
                  }, 8, ["title", "class"]), [
                    [_vShow, _ctx.showCard > 2 ]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Card, {
                      title: _ctx.$t('getMagnets.title3'),
                      class: "w-full mt-4 sm:-mt-8 sm:ml-auto",
                      close: "",
                      onClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectCard(3)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", {
                          innerHTML: _ctx.$t('getMagnets.text7'),
                          class: "text-justify"
                        }, null, 8, _hoisted_22),
                        _createElementVNode("p", {
                          innerHTML: _ctx.$t('getMagnets.text8'),
                          class: "mt-4 text-justify"
                        }, null, 8, _hoisted_23),
                        _createElementVNode("span", {
                          class: "underline cursor-pointer",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
                          innerHTML: _ctx.$t('getMagnets.checkVideo')
                        }, null, 8, _hoisted_24)
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _hoisted_25
                  ], 512), [
                    [_vShow, _ctx.showCard === 4]
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Modal, {
              modelValue: _ctx.isModalShown,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isModalShown) = $event)),
              close: _ctx.closeModal
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_Card, {
                    "wrapper-class": "h-full",
                    close: "",
                    onClosed: _ctx.closeModal
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27,
                      _createElementVNode("p", {
                        innerHTML: _ctx.$t('getMagnets.text9')
                      }, null, 8, _hoisted_28)
                    ]),
                    _: 1
                  }, 8, ["onClosed"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "close"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ]))
}